import { useEffect, useState } from "react";
import { GlobalTable } from "../../../global/components/GlobalTable";
import { useNavigate, useSearchParams } from "react-router-dom";
import useGet from "../../../global/hooks/useGet";
import { DeviceColumns } from "./Columns";
import ConfirmModal from "../../../global/components/ConfirmModal";
import useDelete from "../../../global/hooks/useDelete";
import {
  openConfirmNotification,
  openErrorNotification,
} from "../../../global/utils/toast";
import { DeviceFilter } from "../Components/FilterComponent";
import CommonBreadcrumb from "../../../global/components/CommonBreadcrumb";
import { getUserRole } from "../../../global/hooks/getUserRole";
import CommonButton from "../../../global/components/CommonButton";
import { RiExportFill } from "react-icons/ri";
import { Button, Col, Form, Modal, Row } from "antd";
import CustomSelect from "../../../global/components/inputWidgets/CustomSelect";
import { getModifiedResponse } from "../../../global/utils/responseModifier";
import CustomDateTimePicker from "../../../global/components/inputWidgets/CustomDatePicker";
import { IoIosCheckmarkCircleOutline } from "react-icons/io";
import { CloseOutlined } from "@ant-design/icons";
import downloadCsv from "../../../global/utils/downloadCsv";
import usePost from "../../../global/hooks/usePost";

const initialFilterState = {
  DeviceNo: "",
  DeviceName: "",
  Mac: "",
  Product: null,
  Model: null,
  SiteType: null,
  SiteTypeName: "",
  NodeType: null,
  NodeTypeName: "",
  OemNo: "",
  // ProductionNo: "",
  DealerNo: "",
  CustomerNo: "",
  Online: null,
};

export const Device = () => {
  const [hoveredRow, setHoveredRow] = useState(null);
  const [listData, setListData] = useState([]);
  const [params, setParams] = useSearchParams({
    limit: 10,
    sort_by: "DeviceNo",
    order: "desc",
  });
  // console.log("params", params);
  const modParams = { ...Object.fromEntries([...params?.entries()]) } || {}; //
  const initialPagination = {
    current: parseInt(modParams.page) || 1,
    pageSize: parseInt(modParams.limit) || 10,
    total: 0,
  }; //
  const [filter, setFilter] = useState(initialFilterState);
  const [pagination, setPagination] = useState(initialPagination);
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [filterNoValueText, setFilterNoValueText] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [columnsValues, setColumnsValues] = useState([]);
  const [resetTrigger, setResetTrigger] = useState(false);
  const [exportModal, setExportModal] = useState(false);
  const [form] = Form.useForm();
  const [defaultData, setDefaultData] = useState({
    DealerNo: null,
    OemNo: null,
    CustomerNo: null,
    // ProductionNo: null,
  });
  const [OemNo, setOemNo] = useState(null);
  // const [dealerNo, setDealerNo] = useState(null);
  const [shouldFetch, setShouldFetch] = useState(false);

  const navigate = useNavigate();

  const breadcrumbItems = [
    {
      label: "Device",
      href: "/device",
    },
  ];

  // to get table data from API server
  const query = new URLSearchParams(params);

  // Remove unwanted keys
  query.delete("pageSize");
  query.delete("total");
  query.delete("current");
  const updatedQuery = query.toString();
  // console.log("query", query);
  // console.log(query);
  const url = updatedQuery
    ? `${process.env.REACT_APP_API_URL}/api/devices/?${updatedQuery}`
    : `${process.env.REACT_APP_API_URL}/api/devices/`;
  const { data, loading, error, refetch } = useGet(url);

  // console.log("data", data);
  const deleteUrl = `${process.env.REACT_APP_API_URL}/api/devices/bulk-delete/`;
  // selectedRowKeys.length > 1
  //   ? (deleteUrl = `${process.env.REACT_APP_API_URL}/api/devices/delete/`)
  //   : (deleteUrl = `${process.env.REACT_APP_API_URL}/api/devices/delete/${selectedRowKeys}/`);

  const dealerOptionsUrl =
    OemNo || defaultData?.OemNo
      ? `${process.env.REACT_APP_API_URL}/api/dealers/oems/${
          OemNo ? OemNo : defaultData?.OemNo ? defaultData.OemNo : null
        }/dealers/`
      : null;
  const optionUrl = `${process.env.REACT_APP_API_URL}/api/devices/options/`;
  const {
    data: deletedData,
    loading: deletedDataLoading,
    error: deletedDataError,
    // deleteData,
    deleteMultiple,
  } = useDelete(deleteUrl);

  const {
    data: optionsData,
    loading: optionDataLoading,
    error: optionDataError,
    refetch: optionDataRefetch,
  } = useGet(optionUrl);

  const modifiedOems = getModifiedResponse(optionsData, "oems");
  const {
    data: dealerOp,
    loading: delaerOpLoading,
    error: dealerOpError,
    refetch: delaerOpRefetch,
  } = useGet(dealerOptionsUrl);

  const csvQuery = query;
  csvQuery.delete("limit");
  const updatedCsvQuery = csvQuery.toString();

  const exportCodes = updatedCsvQuery
    ? `${process.env.REACT_APP_API_URL}/api/devices/export/?${updatedCsvQuery}`
    : `${process.env.REACT_APP_API_URL}/api/devices/export/`;
  const {
    data: exportData,
    postData,
    error: postError,
    loading: postLoading,
  } = usePost(exportCodes);

  useEffect(() => {
    delaerOpRefetch();
  }, [OemNo]);

  useEffect(() => {
    const matchedFilter = {};
    for (const key in initialFilterState) {
      if (modParams[key] !== undefined) {
        matchedFilter[key] = modParams[key];
      }
    }

    setFilter((prev) => ({
      ...prev,
      ...matchedFilter,
    }));
  }, []); //

  const paginationConfig = {
    current: pagination.current,
    pageSize: pagination.pageSize,
    total: data?.count,
    showSizeChanger: true,
    pageSizeOptions: [10, 20, 50, 100],
    showTotal: (total, range) => `Total ${total} items ${range[0]}-${range[1]}`,
    onChange: (page, pageSize) => {
      setPagination({
        ...pagination,
        current: page,
        pageSize: pageSize,
      });

      const updatedParams = {
        ...Object.fromEntries([...params.entries()]),
        limit: pageSize,
        page: page,
      };
      setParams(updatedParams);
    },
  }; //
  const onSelectChange = (newSelectedRowKeys) => {
    setSelectedRowKeys(newSelectedRowKeys);
    // navigate(`/oemlist/${newSelectedRowKeys}`);
  };

  const rowSelection = {
    selectedRowKeys,
    onChange: onSelectChange,
    fixed: true,
  };

  const onRow = (record) => {
    return {
      onClick: (event) => {
        navigate(`/device/info/${record?.DeviceNo}`);
      },
    };
  };

  const handleFilterChange = (e) => {
    const inputName = e.target.name;
    const inputValue = e.target.value.replace(/['""`''""]/g, "");
    setFilter({ ...filter, [inputName]: inputValue });
  };

  const handleFilter = (e) => {
    const filterDict = {};
    for (const key in filter) {
      if (
        filter[key] !== null &&
        filter[key] !== "" &&
        filter[key] !== undefined
      ) {
        filterDict[key] = filter[key];
      }
    }
    // console.log("filterDict", filterDict);
    const isEmpty = JSON.stringify(filterDict) === "{}";

    if (isEmpty) {
      setFilterNoValueText("No value exists!");
      handleReset();
    } else {
      const params = {
        limit: 10,
        sort_by: "DeviceNo",
        order: "desc",
        page: 1,
        ...filterDict,
      };
      setPagination((prev) => ({ ...prev, current: 1 }));
      setParams(params);
      refetch();
    }
  };

  // reset
  const handleReset = (e) => {
    // Reset the filter state to the initial state
    setFilter({
      current: 1,
      pageSize: 10,
      total: 0,
    }); //
    setPagination({
      current: 1,
      pageSize: 10,
      total: 0,
    }); //

    // Define the new parameters for the API call
    const params = {
      limit: 10,
      sort_by: "DeviceNo", // Make sure to specify sorting if necessary
      order: "desc",
    };

    // Update the parameters in the state
    setParams(params);
    refetch();
    setSelectedRowKeys([]);
    setResetTrigger(!resetTrigger);
  };

  const onDeleteConfirm = async () => {
    try {
      // if (selectedRowKeys.length === 1) {
      //   await deleteData();
      // } else {
      await deleteMultiple({ ids: selectedRowKeys });
      // }
    } catch (error) {
      openErrorNotification("Something went wrong.");
    }
    setShowModal(false);
    setSelectedRowKeys([]);
  };

  useEffect(() => {
    if (deletedData && !deletedDataError) {
      openConfirmNotification("Success");
      refetch();
    } else if (deletedDataError) {
      openErrorNotification(
        deletedDataError?.response?.data?.message || "Something went wrong",
      );
    }
  }, [deletedData, deletedDataError]);

  useEffect(() => {
    if (data && !loading) {
      const newData = data?.data?.map((el) => ({
        ...el,
        key: el?.DeviceNo,
      }));
      setListData(newData);
    }
  }, [data, loading]);

  const handleExportClick = async (values) => {
    console.log(values);
    const modifiedValues = {
      ...values,
      month: new Date(values.month).toISOString().slice(0, 7),
    };
    try {
      await postData(modifiedValues);
      // setShouldFetch(true);
    } catch (error) {
      console.error(error);
      openErrorNotification("Something went wrong.");
    }
  };
  console.log();

  useEffect(() => {
    if (postError) {
      openErrorNotification(
        postError?.response?.data?.message || "Something went wrong.",
      );
    } else if (postData && !postLoading) {
      console.log(exportData);
      if (exportData?.message === "No devices found.") {
        return openErrorNotification("No Data Found");
      }
      setTimeout(() => {
        if (exportData) {
          const location = window.location;
          downloadCsv(exportData, location);
          openConfirmNotification("Success");
        }
      }, 100);

      // openConfirmNotification("Success");
      // setExportModal(false); // Close the modal on success
    }
  }, [exportData, postError, postLoading]);
  return (
    <div>
      <div className="pb-4 -mt-4 pt-[6px]">
        <CommonBreadcrumb breadcrumbItems={breadcrumbItems}>
          <CommonButton
            buttonsData={[
              {
                label: "Activation Report",
                icon: <RiExportFill className="!text-[14px] font-medium" />,
                onClick: () => {
                  // setShouldFetch(true);
                  // setTimeout(() => {
                  //   handleExportClick();
                  // }, 200);
                  setExportModal(true);
                },
              },
            ]}
          />
        </CommonBreadcrumb>
      </div>
      <div className="p-4 bg-white rounded-[4px] border border-gray-200">
        <DeviceFilter
          filter={filter}
          handleFilterChange={handleFilterChange}
          handleFilter={handleFilter}
          handleReset={handleReset}
          setShowModal={setShowModal}
          selectedRowKeys={selectedRowKeys}
          setFilter={setFilter}
          data={data}
          setColumnsValues={setColumnsValues}
        />
        <ConfirmModal
          showModal={showModal}
          setShowModal={setShowModal}
          onDeleteConfirm={onDeleteConfirm}
          setSelectedRowKeys={setSelectedRowKeys}
        />
        <div className="mt-4">
          <GlobalTable
            columns={DeviceColumns(
              hoveredRow,
              setShowModal,
              setSelectedRowKeys,
              setParams,
              params,
              columnsValues,
            )}
            dataSource={listData}
            rowSelection={
              [1, 2, 3].includes(getUserRole()) ? rowSelection : null
            }
            pagination={paginationConfig}
            onRow={(record, rowIndex) => {
              return {
                onMouseEnter: () => setHoveredRow(rowIndex),
                onMouseLeave: () => setHoveredRow(null),
                ...onRow?.(record, rowIndex),
              };
            }}
            loading={loading}
            resize
            resetTrigger={resetTrigger}
          />
        </div>
      </div>
      <Modal
        title={
          <div className="flex items-center bg-gray-200 p-2 rounded-md">
            <RiExportFill className="text-[20px] text-black pl-1 " />
            <span className="text-[14px] font-[Poppins]   ml-2">
              <p>Activation Report</p>
            </span>
          </div>
        }
        open={exportModal}
        closable={false}
        onCancel={() => {
          setExportModal(false);
          setDefaultData({
            DealerNo: null,
            OemNo: null,
            CustomerNo: null,
            // ProductionNo: null,
          });
          setOemNo(null);
          form.resetFields();
        }}
        footer={null}
        width={580}
        centered
        destroyOnClose
        onClose={() => {
          setDefaultData({
            DealerNo: null,
            OemNo: null,
            CustomerNo: null,
            // ProductionNo: null,
          });
          setOemNo(null);
          form.resetFields();
        }}
      >
        <Form
          validateTrigger={"onChange"}
          form={form}
          onFinish={(values) => {
            setTimeout(() => {
              handleExportClick(values);
            }, 200);
          }}
          scrollToFirstError
          layout={"vertical"}
          autoComplete={"off"}
        >
          <div className="bg-white rounded-[4px] overflow-hidden">
            <div className="px-2 pt-1 pb-3">
              <Row gutter={[0, 0]}>
                <Col span={24}>
                  <CustomSelect
                    label="OEM"
                    name="oem_no"
                    options={modifiedOems}
                    // disabled={type === "info" || accountDefaultData?.OemNo}
                    placeholder="Please select"
                    onChange={(value) => {
                      setDefaultData((prev) => ({
                        ...prev,
                        OemNo: value,
                        DealerNo: null,
                      }));
                      setOemNo(value);
                      // setDealerNo(null);
                      form.setFieldsValue({
                        DealerNo: null,
                      });
                    }}
                    required
                    // handleCreateNew={
                    //   accountDefaultData?.OemNo ? null : handleCreateNew
                    // }
                    type={"OEM"}
                    // loading={loading}
                  />
                </Col>
                <Col span={24}>
                  <CustomSelect
                    label="Dealer"
                    name="DealerNo"
                    required
                    options={
                      dealerOp?.data?.map((item) => ({
                        label: item.name,
                        value: item.value,
                      })) || []
                    }
                    disabled={
                      // defaultData?.OemNo
                      //   ? !defaultData?.OemNo
                      //   : accountDefaultData?.OemNo
                      //   ? !accountDefaultData?.OemNo
                      //   : !selectedOemNo ||
                      defaultData?.OemNo ? !defaultData?.OemNo : !OemNo
                    }
                    placeholder="Please select"
                    onChange={(value) => {
                      setDefaultData((prev) => ({
                        ...prev,
                        DealerNo: value,
                      }));
                      // setDealerNo(value);
                      // form.setFieldsValue({
                      //   CustomerNo: null,
                      // });
                    }}
                    // handleCreateNew={handleCreateNew}
                    type={"Dealer"}
                  />
                </Col>
                <Col span={24}>
                  <CustomDateTimePicker
                    name="month"
                    label="Month"
                    placeholder="Please select"
                    picker={"month"}
                    required
                  />
                </Col>
              </Row>
            </div>
          </div>
          <div className="flex justify-center space-x-2 mt-2.5">
            <Button
              type="primary"
              className="mr-2 min-w-[104px] h-[30px] py-1 px-[10px] font-medium flex items-center "
              onClick={() => form.submit()}
              // loading={postLoading}
            >
              <IoIosCheckmarkCircleOutline className="!text-[14px] font-medium" />
              <span className="">Apply</span>
            </Button>
            <Button
              className="reset-button"
              onClick={() => {
                setExportModal(false);
                setDefaultData({
                  DealerNo: null,
                  OemNo: null,
                  CustomerNo: null,
                  // ProductionNo: null,
                });
                setOemNo(null);
                form.resetFields();
              }}
            >
              <CloseOutlined />
              <span className="">Cancel</span>
            </Button>
          </div>
        </Form>
      </Modal>
    </div>
  );
};
